import { Avatar, Container, Group, Paper, Stack, Text, Title, UnstyledButton } from '@mantine/core';
import { UserSwitchIcon } from '@phosphor-icons/react';

import { useSelectUserMutation } from '#data/user/useSelectUserMutation.ts';
import { useUserListQuery } from '#data/user/useUserListQuery.ts';

const initials = (firstName?: string | null, lastName?: string | null) => {
  const parts = [firstName, lastName].filter((part): part is string => !!part);
  return parts.map((part) => part[0]).join('') || '?';
};

export const LogInAs = () => {
  const { mutate: loginAs } = useSelectUserMutation();
  const { data: users } = useUserListQuery();

  return (
    <Container pb={60} pt={60} size="xs">
      <Stack align="center" gap="xs" mb="xl">
        <UserSwitchIcon size={40} weight="duotone" />
        <Title order={2}>Switch to Promoter</Title>
        <Text c="dimmed" maw={360} size="sm" ta="center">
          You are signed in as an admin. Select a promoter account below to view and manage their events.
        </Text>
      </Stack>

      <Paper withBorder p={4} radius="md" shadow="sm">
        <Stack gap={0}>
          {users?.map((user, index) => (
            <UnstyledButton
              key={user.id}
              p="xs"
              style={(theme) => ({
                borderRadius: theme.radius.sm,
                borderBottom: index < (users?.length ?? 0) - 1 ? `1px solid ${theme.colors.gray[2]}` : undefined,
                '&:hover': { backgroundColor: theme.colors.gray[0] },
              })}
              onClick={() =>
                loginAs(user.id, {
                  onSuccess: () => {
                    // Force full navigation to ensure loaders re-run with fresh localStorage
                    globalThis.location.href = '/';
                  },
                })
              }
            >
              <Group>
                <Avatar color="blue" radius="xl" size="sm">
                  {initials(user.first_name, user.last_name)}
                </Avatar>
                <div>
                  {user.first_name || user.last_name ? (
                    <>
                      <Text fw={500} size="sm">
                        {[user.first_name, user.last_name].filter(Boolean).join(' ')}
                      </Text>
                      <Text c="dimmed" size="xs">
                        {user.email}
                      </Text>
                    </>
                  ) : (
                    <Text fw={500} size="sm">
                      {user.email}
                    </Text>
                  )}
                </div>
              </Group>
            </UnstyledButton>
          ))}
        </Stack>
      </Paper>
    </Container>
  );
};
